export interface HashmapStateUpdateOptions {
  shouldReloadOnAging: boolean;
  numberOfSecondsToTreatAsStaleState: number;
}

export interface StateBase {
  lastModified: number;
}

export abstract class HashmapStateBase<T extends StateBase> {
  private readonly hashmap = new Map<string, T>();

  stateOlderThan(key: string, seconds: number): boolean {
    if (seconds < 0) {
      throw new Error('"seconds" parameter cannot be negative');
    }

    if (!this.hashmap.has(key)) {
      return true;
    }

    const state = this.hashmap.get(key)!;
    const lastModifiedDate = state.lastModified;

    if (lastModifiedDate === -1) {
      return true;
    }

    return (Date.now() - lastModifiedDate) / 1000 > seconds;
  }

  getState(key: string): T {
    if (this.hashmap.has(key)) {
      return this.hashmap.get(key)!;
    }
    const state = this.createState();
    this.hashmap.set(key, state);
    return state;
  }

  protected abstract createState(): T;
}
